export const ipconfig = '116.115.106.58:8001'



// WEBPACK FOOTER //
// ./src/assets/js/ipconfig.js